import { processStages } from '@/mocks/home';

export default function ProcessSection() {
  return (
    <section id="process" className="border-b border-background-200 bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-route-line text-sm" />
              全过程梳理
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              四步看懂一件事的来龙去脉
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-background-300 md:text-base">
              把零散讨论归到四个阶段里，每个阶段只保留最关键的核实点，避免被情绪带着走。
            </p>
          </div>
          <a
            href="#subscribe"
            className="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            订阅阶段更新
            <i className="ri-notification-3-line text-base" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {processStages.map((stage, index) => (
            <div
              key={stage.step}
              className="relative overflow-hidden rounded-lg border border-background-800 bg-background-900/40 p-5"
            >
              <span className="font-heading text-4xl font-black text-background-700">{stage.step}</span>
              <h3 className="mt-2 font-heading text-lg font-bold text-background-50">{stage.name}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-background-300">{stage.desc}</p>
              <div className="mt-4 flex items-center gap-2 border-t border-background-800 pt-3 text-xs text-accent-400">
                <i className="ri-checkbox-circle-line text-sm" />
                {stage.keyPoint}
              </div>
              {index < processStages.length - 1 ? (
                <i className="ri-arrow-right-line absolute right-4 top-5 hidden text-xl text-background-700 lg:block" />
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}